<template>
  <v-layout row wrap justify-center align-center :style="styles">
    <v-flex xs12 class="text-xs-center">
      <v-icon x-large class="grey--text text--lighten-1">info_outline</v-icon> <slot>Sin asignar</slot>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    minHeight: {
      type: String,
      default: '392px',
    },
  },
  computed: {
    styles() {
      return [
        {
          'min-height': this.minHeight,
        },
      ];
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/global/Info.vue